import React from 'react';
import { Grid } from '@material-ui/core';
import intl from 'react-intl-universal';
import CurrencyFormat from 'react-currency-format';
import BackIcon from '@material-ui/icons/ChevronLeft';
import Button from 'src/ui/library/Button';

const ListHeader = (results, pageType) => {
  const items = [];

  results.forEach((result, index) => {
    items.push(
      <Grid item xs={3} className="header-field-grid">
        <div className="header-field travel-scenario nohover">
          <label className="field-label">{result.misc.headerLabel}</label>
          <span className="field-text-travel-scenario">{result.misc.headerText}</span>
        </div>
      </Grid>,
    );
  });

  let sumCost = 0;
  let numEmployees = 0;
  results.forEach(result => {
    sumCost += result.totalCompensationWithEmployees;
    numEmployees += result.numEmployees;
  });

  if (pageType === 'compare') {
    items.push(
      <Grid item xs={3} className="header-field-grid">
        <div className="header-field details nohover">
          <label className="field-label">{intl.get('whatif.headerLabels.comparePage')}</label>
          <span className="field-text-information">
            <b>{numEmployees + ' employees '} </b> {'is '}
            <b>
              <CurrencyFormat
                value={sumCost}
                displayType={'text'}
                thousandSeparator={true}
                decimalScale={2}
                prefix={intl.get('whatif.calculator.currency.prefix')[results[0].outputCurrency]}
                suffix={intl.get('whatif.calculator.currency.suffix')[results[0].outputCurrency]}
              />
            </b>
          </span>
        </div>
      </Grid>,
    );
  } else if (pageType === 'detail') {
    items.push(
      <Grid item xs={3} className="header-field-grid">
        <div className="header-field details nohover">
          <label className="field-label">{intl.get('whatif.headerLabels.detailPage')}</label>
          <span className="field-text-information">
            {'You sent '}
            <b>{numEmployees + ' ' + results[0].classification + (numEmployees > 1 ? 's ' : ' ')}</b>
            {'from '}
            <b>{results[0].homeCountry + ' to ' + results[0].hostCountry + ' '}</b>
            {'for '}
            <b>{results[0].duration}</b>
          </span>
        </div>
      </Grid>,
    );
  }

  return items;
};

class WhatIfHeaderPres extends React.Component {
  render() {
    const { onBack, pageType, results } = this.props;

    return (
      <div className="whatif-header">
        <div className="history-display-wrapper">
          <Button
            styleType={'back-button'}
            onClick={event => {
              onBack();
            }}>
            <div className={'history-display-button-wrapper white'}>
              <div>
                <BackIcon className="history-display-icon" />
              </div>
              <div className="history-display-text">Back</div>
            </div>
          </Button>
        </div>
        <Grid container className="whatif-header-grid" spacing={0}>
          {ListHeader(results, pageType)}
        </Grid>
      </div>
    );
  }
}

export default WhatIfHeaderPres;
